<ng-container *ngIf="formViewModel_() as formViewModel">
	<form [formGroup]="formViewModel.formGroup" class="space-y-6">
		<ng-container
			*ngFor="let sectionVm of formViewModel.sections; trackBy: trackBySection"
		>
			<core-section
				[title]="sectionVm.section.title"
				[collapsable]="true"
				class="p-6"
			>
				<div class="mb-6">
					<p class="text-gray-600 mb-2">
						{{ sectionVm.section.description }}
					</p>
					<p
						class="text-sm text-gray-500 italic"
						*ngIf="sectionVm.section.note"
					>
						{{ sectionVm.section.note }}
					</p>
				</div>

				<div class="grid grid-cols-1 md:grid-cols-3 gap-6">
					<ng-container
						*ngTemplateOutlet="
							itemRenderer;
							context: { items: sectionVm.items }
						"
					></ng-container>
				</div>

				<ng-template #itemRenderer let-items="items">
					<ng-container *ngFor="let itemVm of items; trackBy: trackByItem">
						<ng-container
							*ngIf="isFieldViewModel(itemVm) && itemVm.isVisible_()"
						>
							<app-form-field
								[field]="itemVm.field"
								[control]="itemVm.control"
								[class]="
									itemVm.field.type === FormFieldTypeEnum.FILE ||
									itemVm.field.type === FormFieldTypeEnum.RADIO_GROUP ||
									itemVm.field.type === FormFieldTypeEnum.TEXT_AREA
										? 'md:col-span-3'
										: ''
								"
							></app-form-field>
						</ng-container>

						<core-section
							class="md:col-span-3 space-y-4"
							[title]="itemVm.subSection.title"
							[collapsable]="false"
							*ngIf="isSubSectionViewModel(itemVm) && itemVm.isVisible_()"
						>
							<p
								class="text-sm text-gray-600 mb-4"
								*ngIf="itemVm.subSection.description"
							>
								{{ itemVm.subSection.description }}
							</p>
							<p
								class="text-sm text-gray-500 italic mb-4"
								*ngIf="itemVm.subSection.note"
							>
								{{ itemVm.subSection.note }}
							</p>

							<div class="grid grid-cols-1 md:grid-cols-3 gap-6">
								<ng-container
									*ngTemplateOutlet="
										itemRenderer;
										context: { items: itemVm.fields }
									"
								></ng-container>
							</div>
						</core-section>
					</ng-container>
				</ng-template>
			</core-section>
		</ng-container>
	</form>
</ng-container>
